// extracted by mini-css-extract-plugin
export default {"drawer_container_container":"drawer-container_drawer_container_container__1PM4X","animateMove":"drawer-container_animateMove__TJrKJ","overlay":"drawer-container_overlay__SzFlf"};